// src/components/layout/Header/Header.jsx
import React, { useState, useEffect, useRef } from "react";
import { useLocation, Link } from "react-router-dom";
import { headerLinks } from "../../../json/layout/header";
import "./header.css";
import { X, Menu } from "lucide-react";
import Loader from "../../elements/Loader/Loader";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const location = useLocation();
    const pathname = location.pathname;
    const menuRef = useRef();
    const showToast = useToast();

    // — Zustand store & fetch —
    const header = useStore(state => state.header);
    const loading = useStore(state => state.loading);
    const error = useStore(state => state.error);
    const fetchHeader = useStore(state => state.fetchHeader);

    // 1) Al montar: marcar montado y disparar fetchHeader()
    useEffect(() => {
        setIsMounted(true);
        fetchHeader();
    }, [fetchHeader]);

    // 2) Mostrar toast si error
    useEffect(() => {
        if (error) showToast("error", `❌ Error al cargar Header: ${error}`);
    }, [error, showToast]);

    // 3) Cerrar menú al cambiar ruta
    useEffect(() => {
        setIsOpen(false);
    }, [pathname]);

    // 4) Cerrar menú al click fuera
    useEffect(() => {
        const handleClickOutside = e => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    const toggleMenu = () => setIsOpen(o => !o);

    const base = process.env.REACT_APP_STRAPI_API_BASE.replace("/api", "");
    const logo1 = header[0]?.logoPrincipal?.url;
    const logo2 = header[0]?.logoSecundario?.url;

    if (!isMounted || loading) {
        return <Loader />;
    }

    return (
        <>
            {isOpen && <div className="menu-overlay" />}
            <nav className="navbar navbar-expand-lg navbar-light header-seal">
                <div className="container-fluid container-header-seal">
                    <Link to="/">
                        <div
                            className="navbar-brand"
                            style={{
                                backgroundImage: `url('${base + (logo1 || "")}')`,
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                width: "150px",
                                height: "50px",
                            }}
                        />
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleMenu}
                        aria-controls="navbarNav"
                        aria-expanded={isOpen}
                        aria-label="Toggle navigation"
                    >
                        {isOpen ? <X className="navbar-icon" /> : <Menu className="navbar-icon" />}
                    </button>

                    {isMounted && (
                        <>
                            <div
                                ref={menuRef}
                                className={`collapse navbar-collapse navbar-collapse-seal ${isOpen ? "show" : ""}`}
                                id="navbarNav"
                            >
                                <ul className="navbar-nav">
                                    {headerLinks.map((link, i) => (
                                        <li key={i} className="nav-item">
                                            {link.href.startsWith("#") ? (
                                                <a
                                                    href={link.href}
                                                    className="text-roll nav-link"
                                                    onClick={() => setIsOpen(false)}
                                                >
                                                    <span className="text-roll-container">
                                                        {link.name.split("").map((ch, j) => (
                                                            <span
                                                                key={j}
                                                                className="text-roll"
                                                                style={{ animationDelay: `${j * 100}ms` }}
                                                            >
                                                                {ch === " " ? "\u00A0" : ch}
                                                            </span>
                                                        ))}
                                                    </span>
                                                </a>
                                            ) : (
                                                <Link
                                                    to={link.href}
                                                    className={`text-roll nav-link ${pathname === link.href ? "active" : ""}`}
                                                    aria-current={pathname === link.href ? "page" : undefined}
                                                    onClick={() => setIsOpen(false)}
                                                >
                                                    <span className="text-roll-container">
                                                        {link.name.split("").map((ch, j) => (
                                                            <span
                                                                key={j}
                                                                className="text-roll"
                                                                style={{ animationDelay: `${j * 100}ms` }}
                                                            >
                                                                {ch === " " ? "\u00A0" : ch}
                                                            </span>
                                                        ))}
                                                    </span>
                                                </Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <Link to="/">
                                <div
                                    className="navbar-brand img-years-experience"
                                    style={{
                                        backgroundImage: `url('${base + (logo2 || "")}')`,
                                        backgroundSize: "contain",
                                        backgroundRepeat: "no-repeat",
                                        width: "170px",
                                        height: "60px",
                                    }}
                                />
                            </Link>
                        </>
                    )}
                </div>
            </nav>
        </>
    );
};

export default Header;
